
import {  useReactiveVar } from '@apollo/client';
import { subscriptionsVar } from '@/graphql/state';

export const useSchools = () => {
  const subscriptions = useReactiveVar(subscriptionsVar);

  const hasMultipleChildren = subscriptions.filter(sub => sub.type === 'school').length > 1;

  return {
    subscriptions,
    hasMultipleChildren,
    mySchoolId: 'all',
  }
}
